import React from 'react';
import './scss/error-view.scss';
import ErrorViewProp from './properties/error-view';

function StatusView({status}: ErrorViewProp): React.ReactElement {
    let view = <div/>;
    if (status.message && status.message.length > 0) {
        view = (
            <div className="error-view">
                <div className={status.type}>
                    {status.message}
                </div>
            </div>
        );
    }
    return (
        view
    );
}

export default StatusView;
